import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { formBtn1 } from "../Utils/CustomClasses";
import { useForm } from "react-hook-form";

export default function ViewCompanyModal({
  CompanyModal,
  setCompanyModal,
  row,
}) {
  const {
    reset,
    formState: { errors },
  } = useForm();
  const toggle = () => {
    setCompanyModal(false);
    reset();
  };
  return (
    <>
      <Transition appear show={CompanyModal} as={Fragment}>
        <Dialog as="div" className="relative z-[100]" onClose={toggle}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-scroll">
            <div className="flex items-center justify-center min-h-full p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
                  <Dialog.Title
                    as="h2"
                    className="w-full px-3 py-4 text-lg font-semibold leading-6 text-white bg-base-color font-tb"
                  >
                    Show Company
                  </Dialog.Title>
                  <div className="p-4 sm:flex justify-center ml-9">
                    {/*  content inside the show modal company*/}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:grid-cols-3">
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          Company Name
                        </p>
                        <p>{row?.companyName || "----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          Address1
                        </p>
                        <p>{row?.addressLine1 || "----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          Address2
                        </p>
                        <p>{row?.addressLine2 || "----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          Company Email
                        </p>
                        <p className="break-words">
                          {row?.companyEmail || "-----"}
                        </p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          No of Employees
                        </p>
                        <p>{row?.noOfEmployee || "-----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          No of Roles
                        </p>
                        <p>{row?.noOfRole || "-----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          Phone Number
                        </p>
                        <p>{row?.companyPhone || "-----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          City
                        </p>
                        <p>{row?.city || "-----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          Country
                        </p>
                        <p>{row?.country || "-----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          Loo Break
                        </p>
                        <p>{row?.breakTimeLimit?.loo || "-----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          Lunch Break
                        </p>
                        <p>{row?.breakTimeLimit?.lunch || "-----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          Tea Break
                        </p>
                        <p>{row?.breakTimeLimit?.tea || "-----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          State
                        </p>
                        <p>{row?.state || "-----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          Pincode
                        </p>
                        <p>{row?.pincode ? row?.pincode : "-----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          Color
                        </p>
                        <div className="flex items-center gap-2">
                          <span
                            className="w-3 h-3"
                            style={{ backgroundColor: `var(${row?.color})` }}
                          ></span>
                          {row?.color?.replace("--", "")}
                        </div>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          Islisted
                        </p>
                        <p>{row?.isListed ? "Yes" : "No"}</p>
                      </div>
                      <div className="sm:col-span-2 md:col-span-3">
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          Allowed Lead Table Fields
                        </p>

                        {row?.allowedLeadTableFields?.length ? (
                          <div className="flex flex-wrap gap-2 mt-2">
                            {row.allowedLeadTableFields.map((field) => (
                              <span
                                key={field}
                                className="px-2 py-1 text-sm border rounded-md bg-slate-50 text-slate-700"
                              >
                                {field}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <p>-----</p>
                        )}
                      </div>
                      <div className="sm:col-span-2 md:col-span-3">
                        <p className="font-sans-serif font-bold text-[20px] text-black">
                          Allowed Lead Status
                        </p>

                        {row?.allowedLeadStatus?.length ? (
                          <div className="flex flex-wrap gap-2 mt-2">
                            {row.allowedLeadStatus.map((field) => (
                              <span
                                key={field}
                                className="px-2 py-1 text-sm border rounded-md bg-slate-50 text-slate-700"
                              >
                                {field}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <p>-----</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                    <button
                      type="button"
                      className="w-auto lg:px-8 px-4 transition-colors font-tb tracking-wide duration-200 py-2.5 overflow-hidden text-base font-semibold text-center text-base-color border-2 border-base-color rounded-lg hover:text-white hover:bg-[var(--bg-base-color)] capitalize"
                      onClick={toggle}
                    >
                      Close
                    </button>
                  </footer>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
